import { __RouterContext } from 'react-router-dom';
import { useContext } from 'react';

const useMatch = () => {
  const { match } = useContext(__RouterContext);
  return match;
};

export default useMatch;
